export default {
  contacts: [
    { name: 'phone', text: '+261 34 96 520 96', href: 'tel:+261349652096', icon: require('./icons/phone.svg').default },
    { name: 'mail', text: 'marson.laza@gmail.com', href: 'mailto:marson.laza@gmail.com', icon: require('./icons/mail.svg').default },
    { name: 'skype', text: 'Marson LJ', href: 'https://join.skype.com/invite/iS3INQ0lGyz5', icon: require('./icons/skype.svg').default },
    { name: 'website', text: 'idjitjohn.github.io', href: 'https://idjitjohn.github.io', icon: require('./icons/website.svg').default },
    { name: 'position', text: 'Madagascar', href: '', icon: require('./icons/pin.svg').default }
  ],
  socials: [
    { name: 'linkedin', text: 'Marson John LAZA', href: 'https://www.linkedin.com/in/marsonlj', icon: require('./icons/linkedin.svg').default },
    { name: 'github', text: '@idjitjohn', href: 'https://github.com/idjitjohn', icon: require('./icons/github.svg').default },
    { name: 'stackoverflow', text: 'Marson J.', href: 'https://stackoverflow.com/users/10361518', icon: require('./icons/stackoverflow.svg').default },
  ]
}